import { ThunkResult } from "common/reducers";
import { UiActions } from "common/reducers/ui.actions";
import { RootDispatchType, RootGetState } from "common/store";
import { debounce } from "lodash";
import { isLoading } from "common/selectors/ui.selectors";

const debouncedReset = debounce((dispatch: RootDispatchType, getState: RootGetState) => {
  if (isLoading(getState())) {
    dispatch(UiActions.resetLoading());
  }
}, 60000);

export const UiAsyncActions = {
  resetLoading: (): ThunkResult<void> => {
    return (dispatch: RootDispatchType, getState: RootGetState) => {
      debouncedReset(dispatch, getState);
    };
  },
};
